import { AuthSessionStore } from "./auth_session.js";

export class CachedRequest<T>
{
  private data: T | null = null;
  private owner: number | null = null;
  private fetched_at = 0;
  private pending: Promise<T> | null = null;
  private generation = 0;

  constructor(
    private readonly fetcher: () => Promise<T>,
    private readonly cooldown_ms: number
  ) {}

  public peek(): T | null
  {
    return this.owner === AuthSessionStore.getPlayerId() ? this.data : null;
  }

  public isFresh(): boolean
  {
    return this.peek() !== null && Date.now() - this.fetched_at < this.cooldown_ms;
  }

  public fetch(): Promise<T>
  {
    if ( this.pending )
      return this.pending;

    const owner = AuthSessionStore.getPlayerId();
    const generation = this.generation;
    this.pending = this.fetcher()
      .then( data =>
      {
        if ( generation !== this.generation && this.data !== null && this.owner === owner )
          return this.data;

        this.data = data;
        this.owner = owner;
        this.fetched_at = Date.now();
        return data;
      } )
      .finally( () => { this.pending = null; } );

    return this.pending;
  }

  public update( data: T ): void
  {
    if ( this.owner !== AuthSessionStore.getPlayerId() )
      return;

    this.data = data;
    this.generation++;
  }

  public invalidate(): void
  {
    this.fetched_at = 0;
  }
}
